const englishWithSpecialCharsRegex = /^[a-zA-Z0-9\s!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+$/;
export function isEnglishWithSpecialChars(str) {
    return englishWithSpecialCharsRegex.test(str);
}
